// @flow

import React, { type Node, useEffect } from 'react';
import { useUserInputValue } from '@tectonics/prs/user-input-values';

import { Empty } from '../../../../../commons/atoms';

export function FieldPeruvianDocument(): Node {
  const [value, setValue] = useUserInputValue('peruvianDocument');

  useEffect(() => {
    if (value) {
      setValue('');
    }
  }, [value, setValue]);

  return <Empty />;
}
